<template>
    <Teleport to="#vue-teleport-container">
        <div v-if="show">
            <ScreenOverlay @click="$emit('close')" />

            <div
                :class="{
                    'md:w-180': width === 'wide',
                    'md:w-md': width === 'standard',
                    'right-0': side === 'right',
                    'left-0': side === 'left',
                }"
                class="z-50 h-full fixed top-0 bg-white w-11/12"
            >
                <div class="h-full w-full relative">
                    <template v-if="loading">
                        <div
                            class="absolute top-0 left-0 w-full h-full bg-gray-900 opacity-30 z-10"
                        ></div>
                        <div
                            class="absolute top-0 left-0 w-full h-full z-20 flex items-center justify-center"
                        >
                            <div
                                class="flex flex-col gap-4 justify-center items-center"
                            >
                                <Icon
                                    name="loading-spinner"
                                    class="w-8 h-8 animate-spin text-gray-900"
                                />
                                <div class="text-lg font-bold text-gray-900">
                                    Loading...
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="h-full flex flex-col justify-between">
                        <template v-if="raw">
                            <div>
                                <slot />
                            </div>
                        </template>
                        <template v-else>
                            <div
                                v-if="showCloseButton"
                                class="p-6 text-lg font-semibold text-gray-800 flex justify-between items-center"
                            >
                                <slot name="title">
                                    <div></div>
                                </slot>
                                <ButtonSquareIcon @click="$emit('close')">
                                    <Icon
                                        name="close"
                                        class="w-5 h-5"
                                    />
                                </ButtonSquareIcon>
                            </div>

                            <div
                                v-if="slots.title"
                                class="px-6 pb-6"
                            >
                                <div class="border-b border-b-gray-200"></div>
                            </div>

                            <div
                                class="text-gray-700 h-full overflow-y-auto px-6"
                            >
                                <div class="h-full">
                                    <slot name="content" />
                                </div>
                            </div>

                            <div
                                v-if="slots.actions"
                                class="p-6"
                            >
                                <div
                                    class="pt-6 border-t border-t-gray-200 flex justify-end gap-2"
                                >
                                    <slot name="actions" />
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
    import { useSlots, watch, type PropType } from 'vue'
    import ScreenOverlay from '@/Shared/Component/ScreenOverlay.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import ButtonSquareIcon from '@/Shared/Component/ButtonSquareIcon.vue'

    const emits = defineEmits(['close', 'onDrawerClosed', 'onDrawerOpened'])

    const slots: any = useSlots()

    const props = defineProps({
        raw: {
            type: Boolean,
            default: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String as PropType<'standard' | 'wide'>,
            default: 'standard',
        },
        side: {
            type: String as PropType<'left' | 'right'>,
            default: 'right',
        },
        showCloseButton: {
            type: Boolean,
            default: true,
        },
    })

    watch(
        () => props.show,
        (value) => {
            if (value) {
                emits('onDrawerOpened')
            } else {
                emits('onDrawerClosed')
            }
        },
    )
</script>
